// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Insignia Roman/Insignia Roman.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Insignia Roman";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

.invoice-print-container {
  width: 100%;
  max-width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 1rem;
  font-family: Arial, sans-serif;
  background-color: #fff;
  color: #000;
  box-sizing: border-box;
}

.invoice-print-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background-color: #0f6679;
}

.in-company-name {
  margin: 0.5% 0;
  font-size: 40px;
  font-family: "Insignia Roman", serif;
}

.in-company-address {
  color: #fff;
  text-align: right;
  margin: 0 2% 0 0;
}

.in-company-address p {
  font-size: medium;
  margin: 1.7% 0;
}

.invoice-logo-section {
  height: 100%;
  background-color: #fff;
  border: 1px solid #000;
}

.invoice-logo-section img {
  width: 256px;
}

.invoice-details p {
  display: flex;
  gap: 0.5rem;
  margin: 8% 0;
  align-items: center;
}

.invoice-details .label {
  min-width: 110px;
  display: inline-block;
  color: #000;
  font-size: medium;
  margin: 0%;
}

.invoice-title-block {
  color: #0f6679;
  text-align: center;
  font-weight: bold;
  font-size: 30px;
  margin: 4%;
}

.bill-header {
  display: flex;
  justify-content: space-between;
  background-color: #0f6679;
  color: #fff;
}

.bill-header h4 {
  margin: 1% 2%;
}

.bill-data {
  display: flex;
  justify-content: space-between;
  margin: 0 2%;
}

.bill-to {
  margin-top: 1%;
  text-align: left;
}

.bill-to p {
  margin: 1% 0;
}

.project-company {
  max-width: 50%;
}

.project-address {
  max-width: 45%;
}

.in-print-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.5%;
}

.in-print-table th {
  background-color: #0f6679;
  color: #fff;
  border: 2px solid #7e7e7e;
  padding: 8px;
  text-align: right;
}

.in-print-table td {
  border: 2px solid #7e7e7e;
  padding: 8px;
  text-align: right;
}

.in-print-table th:nth-child(2),
.in-print-table td:nth-child(2) {
  max-width: 500px;
  text-align: left;
}

.in-print-table td:nth-child(1),
.in-print-table th:nth-child(1),
.in-print-table th:nth-child(3),
.in-print-table td:nth-child(3) {
  text-align: center;
}

.tax-section {
  display: flex;
  justify-content: space-between;
}

.partition {
  width: 49%;
  margin: 1% 0;
}

.amount-in-words {
  background-color: #0f6679;
  color: #fff;
  padding: 2%;
  margin: 1% 0;
}

.amount-in-words-text {
  margin: 0 2% 2% 2%;
  font-style: italic;
}

.amounts {
  background-color: #0f6679;
  color: #fff;
  padding: 2%;
  margin: 1% 0 0 1%;
}

.amounts-section {
  margin: 0 2%;
  border-bottom: 2px solid #ccc;
}

.amounts-section p {
  margin: 1%;
}

.terms {
  margin: 0 2%;
  white-space: pre-line;
}

.invoice-footer {
  display: flex;
  gap: 15%;
}

.invoice-footer h4 {
  background-color: #0f6679;
  color: #fff;
  padding: 2%;
  margin: 0;
}

.footer-partition {
  width: 49%;
}

.seal img {
  width: 200px;
  height: 150px;
}

.no-seal {
  width: 200px;
  height: 150px;
}

.seal-sign {
  width: 49%;
  text-align: center;
  margin: 0;
}

.seal-sign p {
  font-size: small;
  margin: 0%;
}

.authorized {
  text-align: center;
  margin: 0;
}

.bank-details {
  display: flex;
  justify-content: space-between;
}

.bank-details p {
  font-size: medium;
}

.qr-code {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1% 2% 0 0;
}

.qr-code img {
  width: 150px;
  height: 150px;
}

.tax-box {
  display: flex;
  justify-content: space-between;
  background-color: #0f6679;
  color: #fff;
  font-weight: bold;
  margin: 1% 0;
}

.tax-box p {
  margin: 2%;
}

.tax-box-body {
  display: flex;
  justify-content: space-between;
  margin: 0;
}

.tax-box-body p {
  margin: 0 2% 0 7%;
  text-align: right;
}

.totals-row {
  font-weight: bold;
  background-color: #f2f2f2;
}

.total-block {
  display: flex;
  justify-content: space-between;
}

.bold {
  font-weight: bold;
}

.note {
  font-size: medium;
  font-style: italic;
  text-align: center;
  color: #3b87fa;
  margin: 5%;
}
`, "",{"version":3,"sources":["webpack://./src/components/UpdateProjects/InvoicePrint.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,+DAAkE;EAClE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ","sourcesContent":["@font-face {\n  font-family: \"Insignia Roman\";\n  src: url(\"./Insignia Roman/Insignia Roman.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.invoice-print-container {\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  padding: 1rem;\n  font-family: Arial, sans-serif;\n  background-color: #fff;\n  color: #000;\n  box-sizing: border-box;\n}\n\n.invoice-print-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  background-color: #0f6679;\n}\n\n.in-company-name {\n  margin: 0.5% 0;\n  font-size: 40px;\n  font-family: \"Insignia Roman\", serif;\n}\n\n.in-company-address {\n  color: #fff;\n  text-align: right;\n  margin: 0 2% 0 0;\n}\n\n.in-company-address p {\n  font-size: medium;\n  margin: 1.7% 0;\n}\n\n.invoice-logo-section {\n  height: 100%;\n  background-color: #fff;\n  border: 1px solid #000;\n}\n\n.invoice-logo-section img {\n  width: 256px;\n}\n\n.invoice-details p {\n  display: flex;\n  gap: 0.5rem;\n  margin: 8% 0;\n  align-items: center;\n}\n\n.invoice-details .label {\n  min-width: 110px;\n  display: inline-block;\n  color: #000;\n  font-size: medium;\n  margin: 0%;\n}\n\n.invoice-title-block {\n  color: #0f6679;\n  text-align: center;\n  font-weight: bold;\n  font-size: 30px;\n  margin: 4%;\n}\n\n.bill-header {\n  display: flex;\n  justify-content: space-between;\n  background-color: #0f6679;\n  color: #fff;\n}\n\n.bill-header h4 {\n  margin: 1% 2%;\n}\n\n.bill-data {\n  display: flex;\n  justify-content: space-between;\n  margin: 0 2%;\n}\n\n.bill-to {\n  margin-top: 1%;\n  text-align: left;\n}\n\n.bill-to p {\n  margin: 1% 0;\n}\n\n.project-company {\n  max-width: 50%;\n}\n\n.project-address {\n  max-width: 45%;\n}\n\n.in-print-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 0.5%;\n}\n\n.in-print-table th {\n  background-color: #0f6679;\n  color: #fff;\n  border: 2px solid #7e7e7e;\n  padding: 8px;\n  text-align: right;\n}\n\n.in-print-table td {\n  border: 2px solid #7e7e7e;\n  padding: 8px;\n  text-align: right;\n}\n\n.in-print-table th:nth-child(2),\n.in-print-table td:nth-child(2) {\n  max-width: 500px;\n  text-align: left;\n}\n\n.in-print-table td:nth-child(1),\n.in-print-table th:nth-child(1),\n.in-print-table th:nth-child(3),\n.in-print-table td:nth-child(3) {\n  text-align: center;\n}\n\n.tax-section {\n  display: flex;\n  justify-content: space-between;\n}\n\n.partition {\n  width: 49%;\n  margin: 1% 0;\n}\n\n.amount-in-words {\n  background-color: #0f6679;\n  color: #fff;\n  padding: 2%;\n  margin: 1% 0;\n}\n\n.amount-in-words-text {\n  margin: 0 2% 2% 2%;\n  font-style: italic;\n}\n\n.amounts {\n  background-color: #0f6679;\n  color: #fff;\n  padding: 2%;\n  margin: 1% 0 0 1%;\n}\n\n.amounts-section {\n  margin: 0 2%;\n  border-bottom: 2px solid #ccc;\n}\n\n.amounts-section p {\n  margin: 1%;\n}\n\n.terms {\n  margin: 0 2%;\n  white-space: pre-line;\n}\n\n.invoice-footer {\n  display: flex;\n  gap: 15%;\n}\n\n.invoice-footer h4 {\n  background-color: #0f6679;\n  color: #fff;\n  padding: 2%;\n  margin: 0;\n}\n\n.footer-partition {\n  width: 49%;\n}\n\n.seal img {\n  width: 200px;\n  height: 150px;\n}\n\n.no-seal {\n  width: 200px;\n  height: 150px;\n}\n\n.seal-sign {\n  width: 49%;\n  text-align: center;\n  margin: 0;\n}\n\n.seal-sign p {\n  font-size: small;\n  margin: 0%;\n}\n\n.authorized {\n  text-align: center;\n  margin: 0;\n}\n\n.bank-details {\n  display: flex;\n  justify-content: space-between;\n}\n\n.bank-details p {\n  font-size: medium;\n}\n\n.qr-code {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 1% 2% 0 0;\n}\n\n.qr-code img {\n  width: 150px;\n  height: 150px;\n}\n\n.tax-box {\n  display: flex;\n  justify-content: space-between;\n  background-color: #0f6679;\n  color: #fff;\n  font-weight: bold;\n  margin: 1% 0;\n}\n\n.tax-box p {\n  margin: 2%;\n}\n\n.tax-box-body {\n  display: flex;\n  justify-content: space-between;\n  margin: 0;\n}\n\n.tax-box-body p {\n  margin: 0 2% 0 7%;\n  text-align: right;\n}\n\n.totals-row {\n  font-weight: bold;\n  background-color: #f2f2f2;\n}\n\n.total-block {\n  display: flex;\n  justify-content: space-between;\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.note {\n  font-size: medium;\n  font-style: italic;\n  text-align: center;\n  color: #3b87fa;\n  margin: 5%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
